import { Option, OptionOnSelectData, Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { JudgementQuestion } from '../../../models';
import { FlexBox } from '../../shared-components/flex-box';
import { SelectOptions } from '../../shared-components/form';
import { SummaryLayout } from './SummaryLayout';
import './JudgingQuestion.scss';

interface Props {
  question: JudgementQuestion;
  index: number;
  isQuestionValidated: boolean;
}

const MAX_SCORE: number = 5;

const JudgingQuestion: React.FC<Props> = props => {
  const { question, index, isQuestionValidated } = props;
  const { nominationForStaffPageUiStore } = useStores();

  const handleOptionSelect = (data: OptionOnSelectData): void => {
    if (!data.optionValue) return;

    nominationForStaffPageUiStore.setJudgementQuestionRating(
      question.questionId,
      Number(data.optionValue),
    );
  };

  return (
    <FlexBox
      isFullWidth
      className='judging-question'
    >
      <SummaryLayout
        title={`Judging question #${index}:`}
        subtitle={question.weight ? `(Weight = ${question.weight}%)` : undefined}
      >
        <FlexBox
          isFullWidth
          content='space-between'
        >
          <Text>{question.question}</Text>
          <FlexBox
            direction='column'
            className='judging-question__score'
          >
            <Text weight='semibold'>My score</Text>
            <Text block>(1 = low, 5 = high)</Text>
            <SelectOptions
              onOptionSelect={handleOptionSelect}
              validationMessage={(isQuestionValidated && question.rating === 0) ? 'Select a rating.' : ''}
              dropdownProps={{
                value: `${question.rating || ''}`,
                selectedOptions: [`${question.rating}`],
              }}
            >
              {
                [...Array(MAX_SCORE)].map((_, i) =>
                  <Option
                    key={`${i + 1}`}
                    value={`${i + 1}`}
                  >
                    {`${i + 1}`}
                  </Option>
                )
              }
            </SelectOptions>
          </FlexBox>
        </FlexBox>
      </SummaryLayout>
    </FlexBox>
  );
}

export default observer(JudgingQuestion);
